import React, { Fragment, Component } from 'react'
import axios from 'axios';
import { Button } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import IconButton from '@mui/material/IconButton';
import { NotificationManager } from 'react-notifications';
import MUIDataTable from "mui-datatables";
// import DateFnsUtils from '@date-io/date-fns';
// import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import TextField from '@mui/material/TextField';

import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class users extends Component {

   constructor(props) {

      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
         fname: '',
         lname: '',
         email: '',
         mobile: '',
         academy: '',
         stdMember: 0,
         role: '',
         password: '',
         gender: '',
         viewdiv: true,
         adddiv: false,
         editdiv: false,
         eid: '',
         edfname: '',
         edlname: '',
         edemail: '',
         edmobile: '',
         edrole: '',
         edacademy: '',
         edgender: '',
         edpassword: '',
         chkbox: false,
         addchkbox: false,
         memberslist: [],
         academylist: [],
         rolelist: [],
         selectedDate: null,
         edselectedDate: null,
      };
      this.addHandleSubmit = this.addHandleSubmit.bind(this);
      this.handleaddCheck = this.handleaddCheck.bind(this);
      this.deleteMember = this.deleteMember.bind(this);
      this.editMember = this.editMember.bind(this);
      this.statusMember = this.statusMember.bind(this);
      this.editHandleSubmit = this.editHandleSubmit.bind(this);
      this.handleeditCheck = this.handleeditCheck.bind(this);
      this.onBackSection = this.onBackSection.bind(this);
      this.onAddSession = this.onAddSession.bind(this);

   }

   componentDidMount() {

      this.getAllMembers();
      this.getAllAcademy();
      this.getAllRoles();
      const role = localStorage.getItem('user_role');
      const usracademy = localStorage.getItem('user_academy');
      if (role == 2) {
         this.setState({ academy: usracademy });
      }
   }


   getAllMembers() {
      axios.get(AppConfig.apiurl + '/api/getmembers', { headers: AuthHeader.header })
         .then(response => {
            const allmembers = response.data.data;
            this.setState({ memberslist: allmembers })
         });
   }

   parseDob(dob) {
      if (!dob || dob === '0000-00-00') {
         return null;
      }
      const parsed = dob instanceof Date ? dob : new Date(dob);
      return isNaN(parsed.getTime()) ? null : parsed;
   }

   handleDateChange = (e, val) => {
      if (val == 1) {
         this.setState({ selectedDate: e });
      } else {
         this.setState({ edselectedDate: e });
      }
   }

   getAllAcademy() {
      axios.get(AppConfig.apiurl + '/api/getacademys', { headers: AuthHeader.header })
         .then(response => {
            const allacademy = response.data.data;
            this.setState({ academylist: allacademy })
         });
   }

   getAllRoles() {
      axios.get(AppConfig.apiurl + '/api/getroles', { headers: AuthHeader.header })
         .then(response => {
            const allroles = response.data.data;
            this.setState({ rolelist: allroles })
         });
   }

   addHandleSubmit(event) {
      event.preventDefault();

      var payload = {
         "fname": this.state.fname,
         "lname": this.state.lname,
         "email": this.state.email,
         "phone": this.state.mobile,
         "password": this.state.password,
         "dob": this.state.selectedDate,
         "roleid": this.state.role,
         "academyid": this.state.academy,
         "gender": this.state.gender,
         "stype": "",
         "joindate": ""
      }
      axios.post(AppConfig.apiurl + '/api/addmember', payload, { headers: AuthHeader.header })
         .then(response => {
            if (response.status == 200) {
               var resdata = response.data;
               if (resdata.status === 1) {
                  NotificationManager.success(resdata.message);
                  this.getAllMembers();
                  this.setState({
                     fname: '',
                     lname: '',
                     email: '',
                     mobile: '',
                     academy: '',
                     password: '',
                     gender: '',
                  });
               } else {
                  NotificationManager.error(resdata.message);
               }
            } else {
               NotificationManager.error('Member not added');
            }

         })
         .catch(error => {
            NotificationManager.error(error);
         });


   }

   handleaddCheck() {
      var chkMember = this.state.stdMember;
      if (chkMember == 0) {
         this.setState({ stdMember: 1, addchkbox: true });
      } else {
         this.setState({ stdMember: 0, addchkbox: false });
      }

   }



   deleteMember(Memberid) {
      this.confirmationDialog.current.openDialog();
      this.memberIdToDelete = Memberid;
   }
   deleteDataPermanent(popupResponse) {
      if (popupResponse) {
         var payload = {
            "id": this.memberIdToDelete
         };

         axios.post(AppConfig.apiurl + '/api/deletemember', payload, { headers: AuthHeader.header })
            .then(response => {
               var resdata = response.data;
               if (resdata.status === 1) {
                  NotificationManager.success(resdata.message);
                  this.getAllMembers();
               } else {
                  NotificationManager.error(resdata.message);
               }
            })
            .catch(error => {
               NotificationManager.error(error);
            });
      }
   }


   editMember(rawdata) {
      this.setState({
         eid: rawdata.uudID,
         edfname: rawdata.uud_firstName,
         edlname: rawdata.uud_lastName,
         edemail: rawdata.uud_email,
         edmobile: rawdata.uud_phone,
         edrole: rawdata.uud_role != null ? rawdata.uud_role : '',
         edacademy: rawdata.uud_academy != null ? rawdata.uud_academy : '',
         edgender: rawdata.uud_gender != null ? String(rawdata.uud_gender) : '',
         edpassword: '',
         edselectedDate: this.parseDob(rawdata.uud_dob),
         viewdiv: false,
         adddiv: false,
         editdiv: true
      });
   }

   editHandleSubmit(event) {
      event.preventDefault();

      var payload = {
         "oid": this.state.eid,
         "fname": this.state.edfname,
         "lname": this.state.edlname,
         "email": this.state.edemail,
         "phone": this.state.edmobile,
         "password": this.state.edpassword,
         "dob": this.state.edselectedDate,
         "roleid": this.state.edrole,
         "academyid": this.state.edacademy,
         "gender": this.state.edgender,
         "stype": "",
         "joindate": ""
      }
      axios.post(AppConfig.apiurl + '/api/editmember', payload, { headers: AuthHeader.header })
         .then(response => {
            var resdata = response.data;
            if (resdata.status === 1) {
               NotificationManager.success(resdata.message);
               this.getAllMembers();
               setTimeout(this.onBackSection, 6000)
            } else {
               NotificationManager.error(resdata.message);
            }

         })
         .catch(error => {
            NotificationManager.error(error);
         });


   }

   handleeditCheck() {
      var chkMember = this.state.edstdMember;
      if (chkMember == 0) {
         this.setState({ edstdMember: 1, chkbox: true });
      } else {
         this.setState({ edstdMember: 0, chkbox: false });
      }

   }

   statusMember(Memberid, status) {

      var payload = {
         "id": Memberid,
         "status": status
      }
      axios.post(AppConfig.apiurl + '/api/statusmember', payload, { headers: AuthHeader.header })
         .then(response => {
            var resdata = response.data;
            if (resdata.status === 1) {
               NotificationManager.success(resdata.message);
               this.getAllMembers();
            } else {
               NotificationManager.error(resdata.message);
            }

         })
         .catch(error => {
            NotificationManager.error(error);
         });

   }

   onBackSection() {
      this.setState({
         viewdiv: true,
         adddiv: false,
         editdiv: false
      });
   }

   onAddSession() {
      this.setState({
         viewdiv: false,
         adddiv: true,
         editdiv: false
      });
   }

   render() {
      const { match } = this.props;
      const columns = ["Name", "Email", "Mobile", "Member", "Academy", "Status", "Edit", "Delete"];
      const options = {
         filterType: 'dropdown'
      };
      const { clients } = this.state.memberslist;

      const memberdata = this.state.memberslist.map((memberval) => {

         if (memberval.uud_status == 1) {
            var stbtn = <a herf='' onClick={() => this.statusMember(memberval.uudID, 0)}><span className="badge badge-info" >Active</span></a>;
         } else {
            var stbtn = <a herf='' onClick={() => this.statusMember(memberval.uudID, 1)}><span className="badge badge-danger" >Inactive</span></a>;
         }
         const ebtn = <IconButton className='text-info' onClick={() => this.editMember(memberval)}><EditOutlinedIcon/></IconButton>;
         const dbtn = <IconButton className="text-danger" aria-label="Delete" onClick={() => this.deleteMember(memberval.uudID)}><DeleteOutlineOutlinedIcon/></IconButton>;
         const stdname = memberval.uud_firstName + " " + memberval.uud_lastName;
         return {
            Name: stdname,
            Email: memberval.uud_email,
            Mobile: memberval.uud_phone,
            Member: memberval.xrl_roleName,
            Academy: memberval.aad_name,
            Status: stbtn,
            Edit: ebtn,
            Delete: dbtn
         }
      });

      return (
         <div className="saas-dashboard">
            <Helmet>
               <title>Members | {AppConfig.appTitle}</title>
               <meta name="description" content="Reactify Sass Dashboard" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.membersheading" />} match={match} />
            <div className="row">
               {this.state.viewdiv &&
                  <div className="col-sm-12 col-lg-12">
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                           title={<div><Button onClick={() => this.onAddSession()} className="btn btn-outline-info"><i className="icon-user-follow"></i> Add members</Button></div>}
                           data={memberdata}
                           columns={columns}
                           options={options}
                        />
                     </RctCollapsibleCard>
                  </div>
               }

               {this.state.adddiv &&
                  <div className="col-sm-6 col-lg-8">
                     <RctCollapsibleCard heading="Add Members">
                        <form autoComplete="off" onSubmit={(e) => this.addHandleSubmit(e)}>
                           <div className="row">
                              <div className="col-sm-12 col-lg-6 col-xl-6">
                                 <div className="form-group">
                                    <TextField id="fname" fullWidth label="First Name" required value={this.state.fname} onChange={evt => this.setState({ fname: evt.target.value })} />
                                 </div>
                                 <div className="form-group">
                                    <TextField type="email" id="email" fullWidth label="Email" required value={this.state.email} onChange={evt => this.setState({ email: evt.target.value })} />
                                 </div>
                                 <FormControl >
                                    <InputLabel htmlFor="age-simple">Role</InputLabel>
                                    <Select inputProps={{ name: 'role', id: 'role', }} required value={this.state.role} onChange={evt => this.setState({ role: evt.target.value })}>
                                       <MenuItem value=""><em>None</em></MenuItem>
                                       {this.state.rolelist.map((rleval, idx) => (
                                          <MenuItem value={rleval.xrlID}>{rleval.xrl_roleName}</MenuItem>
                                       ))}
                                    </Select>
                                 </FormControl>
                                 <div className="form-group"></div>
                                 <FormControl>
                                    <InputLabel htmlFor="age-simple">Gender</InputLabel>
                                    <Select inputProps={{ name: 'gender', id: 'gender', }} required value={this.state.gender} onChange={evt => this.setState({ gender: evt.target.value })}>
                                       <MenuItem value=""><em>None</em></MenuItem>
                                       <MenuItem value="1"><em>Male</em></MenuItem>
                                       <MenuItem value="2"><em>Female</em></MenuItem>
                                    </Select>
                                 </FormControl>
                                 <div className="form-group"></div>
                                 <div className="form-group">
                                    <TextField type="password" id="password" fullWidth label="Password" required value={this.state.password} onChange={evt => this.setState({ password: evt.target.value })} />
                                 </div>
                              </div>
                              <div className="col-sm-12 col-lg-6 col-xl-6">
                                 <div className="form-group">
                                    <TextField id="lname" fullWidth label="Last Name" required value={this.state.lname} onChange={evt => this.setState({ lname: evt.target.value })} />
                                 </div>
                                 <div className="form-group">
                                    <TextField id="mobile" fullWidth label="Mobile" required value={this.state.mobile} onChange={evt => this.setState({ mobile: evt.target.value })} />
                                 </div>
                                 <FormControl fullWidth>
                                    <InputLabel htmlFor="age-simple">Academy</InputLabel>
                                    <Select inputProps={{ name: 'academy', id: 'academy', }} required value={this.state.academy} onChange={evt => this.setState({ academy: evt.target.value })}>
                                       <MenuItem value=""><em>None</em></MenuItem>
                                       {this.state.academylist.map((acdyval, idx) => (
                                          <MenuItem key={acdyval.aadID} value={acdyval.aadID}>
                                             {acdyval.aad_name}
                                          </MenuItem>
                                       ))}
                                    </Select>
                                 </FormControl>
                                 <FormControl fullWidth>
                                    <InputLabel htmlFor="age-simple">Program</InputLabel>
                                    <Select inputProps={{ name: 'academy', id: 'academy', }} required value={this.state.academy} onChange={evt => this.setState({ academy: evt.target.value })}>
                                       <MenuItem value=""><em>None</em></MenuItem>
                                       {this.state.academylist.map((acdyval, idx) => (
                                          <MenuItem key={acdyval.aadID} value={acdyval.aadID}>
                                             {acdyval.aad_name}
                                          </MenuItem>
                                       ))}
                                    </Select>
                                 </FormControl>
                                 <Fragment>
                                    <div className="rct-picker">
                                       <LocalizationProvider dateAdapter={AdapterDateFns}>
                                          <DatePicker
                                             label="Date of Birth"
                                             value={this.state.selectedDate}
                                             onChange={(newValue) => this.handleDateChange(newValue, 1)}
                                             inputFormat="yyyy-MM-dd"
                                             components={{
                                                LeftArrowIcon: () => <i className="zmdi zmdi-arrow-back" />,
                                                RightArrowIcon: () => <i className="zmdi zmdi-arrow-forward" />,
                                             }}
                                             renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
                                          />
                                       </LocalizationProvider>
                                    </div>
                                 </Fragment>
                              </div>
                              <div className="col-sm-12 col-lg-12 col-xl-12">
                                 <div className="form-group">
                                    <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                                    <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackSection} value="Back" />
                                 </div>
                              </div>
                           </div>

                        </form>
                     </RctCollapsibleCard>
                  </div>
               }

               {this.state.editdiv &&
                  <div className="col-sm-6 col-lg-8">
                     <RctCollapsibleCard heading="Edit Members">
                        <form autoComplete="off" onSubmit={(e) => this.editHandleSubmit(e)}>
                           <div className="row">
                              <div className="col-sm-12 col-lg-6 col-xl-6">
                                 <div className="form-group">
                                    <TextField id="fname" fullWidth label="First Name" required value={this.state.edfname} onChange={evt => this.setState({ edfname: evt.target.value })} />
                                 </div>
                                 <div className="form-group">
                                    <TextField type="email" id="email" fullWidth label="Email" required value={this.state.edemail} onChange={evt => this.setState({ edemail: evt.target.value })} />
                                 </div>
                                 <FormControl >
                                    <InputLabel htmlFor="age-simple">Role</InputLabel>
                                    <Select inputProps={{ name: 'role', id: 'role', }} required value={this.state.edrole} onChange={evt => this.setState({ edrole: evt.target.value })}>
                                       <MenuItem value=""><em>None</em></MenuItem>
                                       {this.state.rolelist.map((rleval, idx) => (
                                          <MenuItem value={rleval.xrlID}>{rleval.xrl_roleName}</MenuItem>
                                       ))}
                                    </Select>
                                 </FormControl>
                                 <div className="form-group"></div>
                                 <FormControl>
                                    <InputLabel htmlFor="age-simple">Gender</InputLabel>
                                    <Select inputProps={{ name: 'gender', id: 'gender', }} required value={this.state.edgender} onChange={evt => this.setState({ edgender: evt.target.value })}>
                                       <MenuItem value=""><em>None</em></MenuItem>
                                       <MenuItem value="1"><em>Male</em></MenuItem>
                                       <MenuItem value="2"><em>Female</em></MenuItem>
                                    </Select>
                                 </FormControl>
                                 <div className="form-group"></div>
                                 <div className="form-group">
                                    <TextField type="password" id="password" fullWidth label="Password" value={this.state.edpassword} onChange={evt => this.setState({ edpassword: evt.target.value })} />
                                 </div>
                              </div>
                              <div className="col-sm-12 col-lg-6 col-xl-6">
                                 <div className="form-group">
                                    <TextField id="lname" fullWidth label="Last Name" required value={this.state.edlname} onChange={evt => this.setState({ edlname: evt.target.value })} />
                                 </div>
                                 <div className="form-group">
                                    <TextField id="mobile" fullWidth label="Mobile" required value={this.state.edmobile} onChange={evt => this.setState({ edmobile: evt.target.value })} />
                                 </div>
                                 <FormControl fullWidth>
                                    <InputLabel htmlFor="age-simple">Academy</InputLabel>
                                    <Select inputProps={{ name: 'academy', id: 'academy', }} required value={this.state.edacademy} onChange={evt => this.setState({ edacademy: evt.target.value })}>
                                       <MenuItem value=""><em>None</em></MenuItem>
                                       {this.state.academylist.map((acdyval, idx) => (
                                          <MenuItem key={acdyval.aadID} value={acdyval.aadID}>
                                             {acdyval.aad_name}
                                          </MenuItem>
                                       ))}
                                    </Select>
                                 </FormControl>
                                 <Fragment>
                                    <div className="rct-picker">
                                       <LocalizationProvider dateAdapter={AdapterDateFns}>
                                          <DatePicker
                                             label="Date of Birth"
                                             value={this.state.edselectedDate}
                                             onChange={(newValue) => this.handleDateChange(newValue, 2)}
                                             inputFormat="yyyy-MM-dd"
                                             components={{
                                                LeftArrowIcon: () => <i className="zmdi zmdi-arrow-back" />,
                                                RightArrowIcon: () => <i className="zmdi zmdi-arrow-forward" />,
                                             }}
                                             renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
                                          />
                                       </LocalizationProvider>
                                    </div>
                                 </Fragment>
                              </div>
                              <div className="col-sm-12 col-lg-12 col-xl-12">
                                 <div className="form-group">
                                    <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />
                                    <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackSection} value="Back" />
                                 </div>
                              </div>
                           </div>

                        </form>
                     </RctCollapsibleCard>
                  </div>
               }

               <ConfirmationDialog
                  ref={this.confirmationDialog}
                  onConfirm={(res) => this.deleteDataPermanent(res)}
                  data={'Member'}
               />

            </div>
         </div>
      )
   }
}


export default users;